export { getCurrentLanguage, localeDataHash, DEFAULT_LANGUAGE } from 'react-wot-bootstrap/lib/helpers/locale'


let intl = {
    formatMessage(message) {
        return message.defaultMessage
    },
}

export const updateIntl = (newIntl) => {
    intl = newIntl
}

export const formatMessage = (message, values) => {
    return intl.formatMessage(message, values)
}



// WEBPACK FOOTER //
// ./locale.js